import React from 'react';
import CreateDishState from './createDishState/CreateDishState';
import CreateDishControlPanel from './components/ControlPanel/ControlPanel';
import Forms from './components/Forms/Forms';
import ModalWindows from './components/ModalWindows/ModalWindows';

const CreateDishPage: React.FC = () => {
	return (
		<CreateDishState>
			<CreateDishControlPanel />
			<Forms />
			<ModalWindows />
		</CreateDishState>
	);
};

export default CreateDishPage;
